module.exports = __webpack_public_path__ + "img/ian-dooley-hpTH5b6mo2s-unsplash.1e89a223.jpg";